import { useState, useMemo } from 'react'
import moment from 'moment'
import http from 'http'

import Map from './Map'

import {
  FiClock,
  FiCalendar
} from 'react-icons/fi'

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Legend,
  Tooltip,
  CartesianGrid
} from 'recharts'

const CustomTooltip = ( {
  payload,
  label,
  active
} ) => {
  if ( active && payload && payload.length ) {

    return <div
      className="tooltip-table"
    >
      <ul>
        <li>
          <strong>
            km
          </strong>

          <label>
            { label }
          </label>
        </li>

      <li>
        <strong>
          speed
        </strong>

        <label>
          { payload[ 0 ].value } km/h
        </label>
      </li>

    </ul>

      <div>
      </div>
    </div>
  }
}

const TrackSpeedVsDistance = ( {
  route,
  color
} ) => {
  const [ points, setPoints ] = useState()
  const [ point, setPoint ] = useState()

  useMemo( () => {
    http( {
      method: 'GET',
      url: `/track/${ route._id }/speedVsDistance`,
    } )
      .then( ( { data } ) => {
        setPoints( data )
      } )
  }, [ route._id ] )

  const lorem = ( state, a, b ) => {
    if ( ! state || ! state.activeIndex )
      return

    const index = state.activeIndex

    const value = points[ index ]

    setPoint( point => {
      return value
    } )
  }

  if ( ! points ) return null

  return <div className="scroll one hs air-2x in-air-2x gap-2x bg-secondary">

    <div className="vs">
      <div className="one vs gap">
        <span><FiCalendar /></span>

        <span className="one">
          {
            moment.tz( route.at * 1000, route.timezone ).format( 'DD MMM, YYYY' )
          }
        </span>
      </div>

      <div className="one vs gap">
        <span className="one ta-right">
          {
            moment.tz( route.at * 1000, route.timezone ).format( 'HH:mm' )
          }
        </span>

        <span><FiClock /></span>
      </div>
    </div>

    <h1 className="size-3x5 ta-center">{ route.name }</h1>

    <Map
      route={ route }
      color={ color }
      point={ point }
      label={ {
        title: 'km',
        key: 'km'
      } }
      value={ {
        title: 'speed',
        key: 'speed',
        units: 'km/h'
      } }
    />

    <div>
      <LineChart
        style={ {
          width: '100%',
          aspectRatio: 1.618,
          maxHeight: 210
        } }
        data={ points }
        responsive
        onMouseMove={ lorem }
      >

        <Line
          type="monotone"
          dataKey="speed"
          stroke={ color }
          strokeWidth={ 2 }
          name="speed over distance"
        /> 

        <XAxis
          dataKey="km"
          height={ 50 }
          label={ {
            value: 'km',
            position: 'insideBottom'
          } }
        />

        <YAxis width="auto" label={{ value: 'km/h', position: 'insideLeft', angle: -90 }} />

        <Tooltip
          content={ <CustomTooltip /> }
        />

      </LineChart>
    </div>
  </div>
}

export default TrackSpeedVsDistance
